module.exports = __webpack_public_path__ + "15-lined-b4735c8e7078ecd8e6d251d4ab003ae3.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/step-number-icons/lined/15-lined.svg
// module id = 125
// module chunks = 0